module.exports = __webpack_public_path__ + "static/media/4.e3733962.jpg";